/** Desarrollo contra el gateway de integración. */
export const environment = {
  production: false,
  appName: 'Ultra Tax',
  timeoutMs: 15000,

  /** true = login/sesión mock local; false = IAM real (/auth/api) */
  
  /**
   * Base path por micro (relativo, sin CORS gracias al proxy).
   * Al agregar uno nuevo: 1) entrada aquí  2) ruta en proxy.conf.json con su puerto
   */
  useMockAuth: false,
  // microservices: {
  //   /** localhost:2036 — ej. /motivos-cancelacion */
  //  admin: '/admin/api',
  //   /** localhost:2030 — ej. /usuarios (alta, estatus, password) */
  //   auth: '/auth/api',
  //   /** localhost:2042 — ej. /usuarios (listado, detalle), /personas */
  //   profile: '/profile/api',
  //   /** localhost:2038 — ej. /listarDocumentoFiltros, /descargarArchivo */
  //   storage: '/storage/api',
  //   /** localhost:2031/utx-core-trip-service — ej. /history/buscar */
  //   trip: '/trip/api',
  //   /** localhost:2039/utx-ext-support-service — ej. /ratings/conductores/{id} */
  //   support: '/support/api',
  //   /** localhost:2034 — ej. /metodos/listar */
  //   pago: '/pago/api',
  //   /** localhost:2033 — ej. /listarPorVehiculo/{idVehiculo} */
  //   taximeter: '/taximeter/api',
  //   /** localhost:2035 — ej. /timbrar, /cancelar */
  //   billing: '/billing/api',
  //   /** localhost:2037 — ej. /push/send */
  //   notif: '/notif/api'
  //   }

  /** Autenticación real mediante el gateway. */
  // useMockAuth: false,
  microservices: {
    admin: 'https://admin.utx.ittiva.com:2040/admin/api',
    auth: 'https://admin.utx.ittiva.com:2040/auth/api',
    profile: 'https://admin.utx.ittiva.com:2040/profile/api',
    storage: 'https://admin.utx.ittiva.com:2040/storage/api',
    trip: 'https://admin.utx.ittiva.com:2040/trip/api',
    support: 'https://admin.utx.ittiva.com:2040/support/api',
    pago: 'https://admin.utx.ittiva.com:2040/pago/api',
    taximeter: 'https://admin.utx.ittiva.com:2040/taximeter/api',
    billing: 'https://admin.utx.ittiva.com:2040/billing/api',
    notif: 'https://admin.utx.ittiva.com:2040/notif/api'
  }
} as const;
